import { observable, action } from "mobx";
import { post } from "../services/ajax.service";

class PharmacySavingsStore {


  @observable total_data = [];
  @observable Participants_yearly = {};
  @observable Pmpm_yearly = [];
  @observable branded = {};
  @observable generic = {};
  @observable specialty = {};
  @observable total_employees_start_year = 0;
  @observable total_employees = 0;
  @observable total_participants_start_year = 0;
  @observable total_participants = 0;
  @observable total_participant_count = 0;
  @observable total_participant_count_cc = 0;
  @observable total_employees = 0;
  @observable total_spend = 0;
  @observable total_claims = 0;
  @observable average_claim_cost = 0;
  @observable current_month_spend = 0;
  @observable previous_month_spend = 0;
  @observable current_month_plan_spend = 0;
  @observable previous_month_plan_spend = 0;
  @observable inception_savings = 0;
  @observable in_progress = 0;
  @observable saving_details = 0;
  @observable pmpm = 0;
  @observable p_count = 0;
  @observable engagement_approved_physicians = 0;
  @observable engagement_denied_physicians = 0;
  @observable engagement_approved_participants = 0;
  @observable participant_communications = 0;
  @observable approved_savings = 0;
  @observable top_five_approved_drugs = [];
  @observable top_ten_drugs_by_savings = [];
  @observable top_five_drugs_by_generic = [];
  @observable top_five_drugs_by_specialty = [];
  @observable top_five_drugs_by_brand = [];
  @observable top_ten_therapeutic_drugs = [];
  @observable top_five_denied_drugs = [];
  @observable toptiles = {
    total_pariticipants: 0,
    total_spend: 0,
    pmpm: 0,
    total_claims: 0,
    average_claim_cost: 0
  };
  @observable total_savings = 0;
  @observable total_savings_specialty = 0;
  @observable total_savings_generic = 0;
  @observable total_savings_brand = 0;
  @observable intervention_data = [];
  @observable total_spend_summary = [];


  @observable action = false;
  @observable errors = {};
  @observable url = "/api/v1/pharmacySavingsActions";



  @action setErrors = () => {
    this.errors = {};
  };

  @action setAction = action => {
    this.action = action;
  };

  @action getAllUserGroups = async data => {
    this.user_all_groups = [];
    try {
      let response = await post(
        `${this.url}/getAllUserGroups`,
        data
      );

      this.user_all_groups = response.data;
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getTop_5_DrugsDeniedSavings = async data => {
    try {
      let response = await post(
        `${this.url}/getTop_5_DrugsDeniedSavings`,
        data
      );
      this.top_five_denied_drugs = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getTotalActualSavings = async data => {
    const response = await post(
      `${this.url}/getTotalActualSavings`, data
    );
    this.total_savings = response.data[0]?.total_savings;
  }
  @action getSpecialtySavings = async data => {
    const response = await post(
      `${this.url}/getSpecialtySavings`, data
    );
    this.total_savings_specialty = response.data[0]?.Specialty;
  }
  @action getGenericSavings = async data => {
    const response = await post(
      `${this.url}/getGenericSavings`, data
    );
    this.total_savings_generic = response.data[0]?.Generic;
  }
  @action getBrandedSavings = async data => {
    const response = await post(
      `${this.url}/getBrandedSavings`, data
    );
    this.total_savings_brand = response.data[0]?.Branded;
  }
  @action getSpendSummary = async data => {
    const response = await post(
      `${this.url}/getSpendSummary`, data
    );
    this.total_spend_summary = response.data[0];
  }
  @action getInterventionsData = async data => {
    const response = await post(
      `${this.url}/getInterventionsData`, data
    );
    this.intervention_data = response.data[0];
  }

  @action getTop_10_TherapeuticClassBreakdownSavings = async data => {
    try {
      let response = await post(
        `${this.url}/getTop_10_TherapeuticClassBreakdownSavings`,
        data
      );
      this.top_ten_therapeutic_drugs = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getTop_5_GenericDrugsBySavings = async data => {
    try {
      let response = await post(
        `${this.url}/getTop_5_GenericDrugsBySavings`,
        data
      );
      this.top_five_drugs_by_generic = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getTop_5_BrandDrugsBySavings = async data => {
    try {
      let response = await post(
        `${this.url}/getTop_5_BrandDrugsBySavings`,
        data
      );
      this.top_five_drugs_by_brand = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getTop_5_SpecialtyDrugsBySavings = async data => {
    try {
      let response = await post(
        `${this.url}/getTop_5_SpecialtyDrugsBySavings`,
        data
      );
      this.top_five_drugs_by_specialty = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getTop_10_DrugsBySavings = async data => {
    try {
      let response = await post(
        `${this.url}/getTop_10_DrugsBySavings`,
        data
      );
      this.top_ten_drugs_by_savings = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getTop_5_DrugsApprovedSavings = async data => {
    try {
      let response = await post(
        `${this.url}/getTop_5_DrugsApprovedSavings`,
        data
      );
      this.top_five_approved_drugs = response.data;
    } catch (err) {
      console.log(err);
    }
  };
  @action getApprovedSavings = async data => {
    this.total_data = [];
    try {
      let response = await post(
        `${this.url}/getApprovedSavings`,
        data
      );
      this.approved_savings = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };


  @action getSavingsDetail = async data => {
    this.total_data = [];
    try {
      let response = await post(
        `${this.url}/getSavingsDetail`,
        data
      );
      this.saving_details = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };



  @action getTotalPlanSpend = async data => {
    this.total_data = [];
    try {
      let response = await post(
        `${this.url}/getTotalPlanSpend`,
        data
      );
      this.total_data = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };

  @action getTotalParticipantsYearly = async data => {
    this.Participants_yearly = {};
    try {
      let response = await post(
        `${this.url}/getTotalParticipantsYearly`,
        data
      );
      this.Participants_yearly = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };

  @action getPMPMYearly = async data => {
    this.Pmpm_yearly = [];
    try {
      let response = await post(
        `${this.url}/getPMPMYearly`,
        data
      );
      this.Pmpm_yearly = response.data.data[0];
      this.p_count = response.data
    } catch (err) {
      console.log(err);
    }
  };

  @action getBrandedOfYear = async data => {
    this.branded = {};
    try {
      let response = await post(
        `${this.url}/getBrandedOfYear`,
        data
      );
      this.branded = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };

  @action getGenericOfYear = async data => {
    this.generic = {};
    try {
      let response = await post(
        `${this.url}/getGenericOfYear`,
        data
      );
      this.generic = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };

  @action getSpecialtyOfYear = async data => {
    this.specialty = {};
    try {
      let response = await post(
        `${this.url}/getSpecialtyOfYear`,
        data
      );
      this.specialty = response.data[0];
    } catch (err) {
      console.log(err);
    }
  };

  @action getAverageParticipantShip = async data => {
    this.total_employees_start_year = 0;
    this.total_employees = 0;
    this.total_participants_start_year = 0;
    this.total_participants = 0;
    try {
      let response = await post(
        `${this.url}/getAverageParticipantShip`,
        data
      );

      this.total_employees_start_year = response.data?.data?.total_employees_start_year;
      this.total_employees = response.data?.data?.total_employees;
      this.total_participants_start_year = response.data?.data?.total_participants_start_year;
      this.total_participants = response.data?.data?.total_participants;
    } catch (err) {
      console.log(err);
    }
  };

  @action getInProgress = async data => {
    const response = await post(
      `${this.url}/getInProgress`, data
    );
    this.in_progress = response.data[0];
  }
  @action getTotalParticipants = async data => {
    const response = await post(
      `${this.url}/getTotalParticipants`, data
    );
    this.total_participant_count = response.data[0]?.participant_count;
  }
  @action getTotalParticipantsFromCC = async data => {
    const response = await post(
      `${this.url}/getTotalParticipantsFromCC`, data
    );
    this.total_participant_count_cc = response.data[0]?.participant_count_cc;
  }

  @action getTotalEmployees = async data => {
    const response = await post(
      `${this.url}/getTotalEmployees`, data
    );
    this.total_employees = response.data[0]?.employee_count;
  }


  @action getAverageClaimCost = async data => {
    const response = await post(
      `${this.url}/getAverageClaimCost`, data
    );
    this.average_claim_cost = response.data[0].avg_claim_cost;
  }

  @action getTotalClaims = async data => {
    const response = await post(
      `${this.url}/getTotalClaims`, data
    );
    this.total_claims = response.data[0].total_claims_of_group;
  }
  @action getTopTiles = async data => {
    let response = await post(
      `${this.url}/getTopTiles`,
      data
    );
    this.toptiles.total_pariticipants =
      response.data.participants[0].TOTAL_PARTICIPANTS;
    this.toptiles.total_spend = response.data.claims[0].TOTAL_SPEND;
    this.toptiles.pmpm = response.data.pmpm[0].PMPM;
    this.toptiles.total_claims = response.data.claims[0].TOTAL_CLAIMS;
    this.toptiles.average_claim_cost =
      response.data.claims[0].AVERAGE_CLAIM_COST;
  };


  @action getTotalSpend = async data => {
    const response = await post(
      `${this.url}/getTotalSpend`, data
    );
    this.total_spend = response.data[0].total_spend;
  }

  @action getPreviousMonthSpend = async data => {
    const response = await post(
      `${this.url}/getPreviousMonthSpend`, data
    );
    this.previous_month_spend = response.data[0].previous_month_spend;
    this.current_month_spend = response.data[0].current_month_spend;
  }

  @action getPMPM = async data => {
    const response = await post(
      `${this.url}/getPMPM`, data
    );
    this.pmpm = response.data[0].PMPM;
  }

  @action getInceptionSavings = async data => {
    const response = await post(
      `${this.url}/getInceptionSavings`, data
    );
    this.inception_savings = response.data[0]?.inception_savings;
  }

  @action getParticipantCommunications = async data => {
    const response = await post(
      `${this.url}/getParticipantCommunications`, data
    );
    this.participant_communications = response.data[0]?.communication_count;
  }

  @action getApprovedPhysiciansEngagement = async data => {
    const response = await post(
      `${this.url}/getApprovedPhysiciansEngagement`, data
    );
    this.engagement_approved_physicians = response.data[0];
  }

  @action getApprovedParticipantsEngagement = async data => {
    console.log("last rungin");
    const response = await post(
      `${this.url}/getApprovedParticipantsEngagement`, data
    );
    this.engagement_approved_participants = response.data[0];
  }

}

export default PharmacySavingsStore;
